import { type AnimationControlValue, AnimationRadioGroup } from './AnimationRadioGroup';
import { easingOptions, type AnimationEasing } from './animationControlOptions';

type AnimationEasingControlProps = {
    value?: AnimationControlValue<AnimationEasing>;
    defaultValue?: AnimationControlValue<AnimationEasing>;
    onChange?: (value: AnimationControlValue<AnimationEasing>) => void;
};

const AnimationEasingControl = (props: AnimationEasingControlProps) => (
    <AnimationRadioGroup name='easing' options={easingOptions} {...props} />
);

export default AnimationEasingControl;
